import { getFontSize } from "../../../../constants/fontSizes";

export const heroSectionStyles = {
  container: {
    position: 'relative',
    width: '100%',
    height: '100vh',
    overflow: 'hidden',
    padding: {
      lg: '35px 75px',
      xs: "20px"
    },
  },
  video: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    zIndex: 0,
    pointerEvents: 'none', // Prevent clicks so play icon never appears and video can't be paused
  },
  bgMask: {
    position: 'absolute',
    top: 0,
    left: 0,
    width: '100%',
    height: '100%',
    backgroundColor: '#0000004D',
    zIndex: 0.5,
  },
  headerContainer: {
    position: 'relative',
    zIndex: 2,
  },
  centeredTextSection: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    zIndex: 2,
    width: '100%',
    paddingLeft: {
      xs: '15px',
      sm: '30px',
      md: '40px',
      lg: '50px',
      xl: '75px',
    },
    paddingRight: {
      xs: '15px',
      sm: '30px',
      md: '40px',
      lg: '50px',
      xl: '75px',
    },
  },
  typography: {
    fontFamily: "Aurora",
    fontSize: getFontSize(80),
    color: 'secondary.main',
    lineHeight: getFontSize(94),
    letterSpacing: "0%",
    textTransform: "uppercase",
    fontWeight: 700,
  },
};

